import { useSetRecoilState } from "recoil";

import {
  DirectionEnum,
  IRideDto,
  RIDE_START_END_NON_RE_COUNTABLE_TIME_GAP_MINUTES,
  rideHasSignificantTimeChangeAtom,
  timeDiffMinutesSigned,
} from "@ryde/shared";

export const useRideTimeChangeCheck = () => {
  const setRideHasSignificantTimeChange = useSetRecoilState(
    rideHasSignificantTimeChangeAtom,
  );

  const checkRideTimeChange = (
    initialRide: Partial<IRideDto> | undefined,
    currentRide: Partial<IRideDto> | undefined,
  ): void => {
    if (!initialRide?.id || !currentRide?.id) {
      setRideHasSignificantTimeChange(false);
      return;
    }

    const isPickUp = currentRide.direction === DirectionEnum.PickUp;

    // RYDE-4848 - ride without passengers shouldn't respect this time
    const hasPassengers = Boolean(currentRide.metadata?.passengersInfo?.length);

    if (!hasPassengers) {
      setRideHasSignificantTimeChange(false);
      return;
    }

    let timeDiffMinutes = 0;

    if (isPickUp && initialRide.rideEnd && currentRide.rideEnd) {
      timeDiffMinutes = Math.abs(
        timeDiffMinutesSigned(initialRide.rideEnd, currentRide.rideEnd),
      );
    } else if (!isPickUp && initialRide.rideStart && currentRide.rideStart) {
      timeDiffMinutes = Math.abs(
        timeDiffMinutesSigned(initialRide.rideStart, currentRide.rideStart),
      );
    }

    const hasSignificantChange =
      timeDiffMinutes > RIDE_START_END_NON_RE_COUNTABLE_TIME_GAP_MINUTES;

    setRideHasSignificantTimeChange(hasSignificantChange);
  };

  return { checkRideTimeChange };
};
